/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_3_LabelInputs */

const en_svc_agents_art_3_label = /** @type {(inputs: Svc_Agents_Art_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up drafted`)
};

const lv_svc_agents_art_3_label = /** @type {(inputs: Svc_Agents_Art_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilde sagatavota`)
};

/**
* | output |
* | --- |
* | "Follow-up drafted" |
*
* @param {Svc_Agents_Art_3_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_3_label = /** @type {((inputs?: Svc_Agents_Art_3_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_3_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_3_label(inputs)
	return en_svc_agents_art_3_label(inputs)
});